export default __webpack_public_path__ + "ab3895c1cd081078b62d1812dc152b25.png";